import { apiSlice } from './apiSlice';

export const pushApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    subscribeToPush: builder.mutation({
      query: (subscription) => ({
        url: '/push/subscribe',
        method: 'POST',
        body: subscription,
      }),
    }),
    unsubscribeFromPush: builder.mutation({
      query: (endpoint) => ({
        url: '/push/subscribe',
        method: 'DELETE',
        body: { endpoint },
      }),
    }),
  }),
});

export const { useSubscribeToPushMutation, useUnsubscribeFromPushMutation } =
  pushApiSlice;
